import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../../../commonComponents/forms/FormInput';
import LoggedUserContext from '../../../../../contextProviders/LoggedUserContext';
import translate from '../../../../../commonComponents/translate';

function CareerFilters(props) {
  const { loggedUser } = useContext(LoggedUserContext);
  const { _id: loggedUserId } = loggedUser;
  const { t, filters, onFilterChange = [] } = props;
  const { user, userNumber } = filters;

  const inputProps = useCallback(
    field => {
      switch (field) {
        case 'user':
          return {
            allowClear: true,
            url: '/user/table/network/list',
            filterUrl: '/user/table/network/list',
          };
        default:
          return {
            items: [],
          };
      }
    },
    [loggedUserId],
  );

  return (
    <div className="filters-wrapper-modal">
      <div className="career-filter-container">
        <FormInput
          id="users-modal"
          value={user}
          name="users-modal"
          disabled={false}
          placeholder={t('user')}
          type="users"
          onChange={onFilterChange('user')}
          inputProps={inputProps('user')}
        />
      </div>
      <div className="career-filter-container">
        <FormInput
          id="userNumber-modal"
          value={userNumber}
          name="userNumber-modal"
          disabled={false}
          placeholder={t('profile.userNumber')}
          type="text"
          onChange={onFilterChange('userNumber')}
          inputProps={inputProps('userNumber')}
        />
      </div>
    </div>
  );
}

CareerFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    user: PropTypes.string,
    userNumber: PropTypes.string,
  }).isRequired,
};

export default translate(CareerFilters);
